import CtaButtons from './CtaButtons';
import Footer from './Footer';
import FormField from './FormField';
import Header from './Header';
import Icon from './Icon';
import SectionContent from './SectionContent';
import SectionForm from './SectionForm';
import SectionHero from './SectionHero';
import SectionPosts from './SectionPosts';
import SectionProjects from './SectionProjects';
import Layout from './Layout';

export {
    CtaButtons,
    Footer,
    FormField,
    Header,
    Icon,
    SectionContent,
    SectionForm,
    SectionHero,
    SectionProjects,
    SectionPosts,
    Layout
};

export default {
    CtaButtons,
    Footer,
    FormField,
    Header,
    Icon,
    SectionContent,
    SectionForm,
    SectionHero,
    SectionProjects,
    SectionPosts,
    Layout
};
